import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';

// Utilities
import classnames from 'classnames';

// Style
import style from './Style.module.scss';

interface RadioProps {
    label?: string | ReactNode;

    textClassName?: string;
    inputClassName?: string;
}

const Radio = forwardRef<HTMLInputElement, RadioProps & InputHTMLAttributes<HTMLInputElement>>(({ label, className, inputClassName, textClassName, ...props }, ref) => {
    const combinedWrapperClassName = classnames([style.wrapper, className]);
    const combinedtextClassName = classnames([style.text, textClassName]);
    const combinedInputClassName = classnames([style.input, inputClassName]);

    return (
        <label className={combinedWrapperClassName}>
            <input ref={ref} type={'radio'} {...props} className={combinedInputClassName} />

            {label && <span className={combinedtextClassName}>{label}</span>}
        </label>
    );
});

export default Radio;
